import { writable, derived, get } from 'svelte/store';
import { interpret } from 'robot3';
export function useMachine(machine, initialContext) {
    let service;
    const childStore = writable(null);
    const serviceStore = writable(service = interpret(machine, innerService => {
        if (service !== innerService) {
            console.log({ childStore: { service, innerService } });
            childStore.set(innerService);
        }
        else {
            console.log({ service: { service, innerService } });
            serviceStore.set(innerService);
            // @ts-ignore
            childStore.set(innerService.child);
        }
    }, initialContext));
    const stateStore = derived(serviceStore, ($store) => $store.machine.current);
    const context = derived(serviceStore, ($store) => $store.context);
    const send = (ev) => get(serviceStore).send(ev);
    return {
        service: serviceStore,
        context: context,
        state: stateStore,
        send: send,
        child: childStore,
    };
}
